
import {v4 as uuidv4} from 'uuid';
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import sm3 from "sm-crypto/dist/sm3.js";
import encrypt from "../util/plugin.js";
import {sync} from 'cross-spawn';

export default {
directives: {
TransferDom
},
components: {
Confirm
},
name: 'livefaceRecognition',
data() {
return {
isDisabled: true,
isRecognition: false,//是否正在识别
second: 3,
show: false,
currentkey: '',
verifycode: '',
key: '',
token: '',
operate: ''
}
},
created() {
let encodeBackurl = this.$route.query.encodeBackurl;
if (encodeBackurl != null && encodeBackurl != "") {
let queryString = window.location.search;
let returnRequestId = window.sessionStorage.getItem('request_id');
if (returnRequestId != null && queryString != null) {
let decodedQueryString = decodeURIComponent(queryString);
let urlParams = new URLSearchParams(decodedQueryString);
let requestId = urlParams.get('request_id');
let msg = urlParams.get('msg');
let code = urlParams.get('code');
if (requestId != "" && requestId != null && requestId == returnRequestId) {
let backurl = Buffer.from(encodeBackurl, 'base64').toString('utf-8');
if (200000 == code) {
backurl += '&valid=1';
} else {
if (backurl.indexOf("&returnMsg=") > 0) {
backurl = backurl.replace(/&returnMsg=.*/, '&returnMsg=' + msg)
} else {
backurl += '&returnMsg=' + msg;
}
}

window.sessionStorage.setItem("pagePositioning", "pagePositioning");
window.location.href = backurl;
} else {
const thiss = this;
thiss.$vux.confirm.show({
content: "请重新进行验证", showCancelButton: false, confirmText: '确认', hideOnBlur: false,
onConfirm() {
thiss.$router.push({
path: '/waitTask',
});
}
})
}
} else {
const thiss = this;
thiss.$vux.confirm.show({
content: "请重新进行验证", showCancelButton: false, confirmText: '确认', hideOnBlur: false,
onConfirm() {
thiss.$router.push({
path: '/waitTask',
});
}
})
}

} else {
this.currentkey = window.sessionStorage.getItem('currentkey');
this.verifycode = this.$route.query.verifycode || '';
this.key = this.$route.query.key || '';
this.token = this.$route.query.token || '';
this.operate = this.$route.query.operate || '';
let interval = setInterval(() => {
if (this.second < 1) {
clearInterval(interval);
this.isDisabled = false;
return
}
this.second -= 1;
}, 1000);

if (this.$route.query.valid) {
this.videoValid();
} else if (this.$route.query.returnMsg != null && this.$route.query.returnMsg != "") {
let pagePositioning = window.sessionStorage.getItem('pagePositioning')
if (pagePositioning != 'pagePositioning' && this.operate == 3) {
this.$router.go(-1);
} else {
const thiss = this;
thiss.$vux.confirm.show({
content: thiss.$route.query.returnMsg, showCancelButton: false, confirmText: '确认', hideOnBlur: false,
onConfirm() {
thiss.$router.go(-1)
}
})
}
} else {
let pagePositioning = window.sessionStorage.getItem('pagePositioning')
if (pagePositioning != 'pagePositioning' && this.operate == 3) {
this.$router.go(-1);
} else {
this.ekycFace();
}
}
}
},
computed: {
verifycodeShow() {
return this.verifycode.split('');
}
},
methods: {
ekycFace() {
if (this.operate == 3) {
window.sessionStorage.removeItem("pagePositioning");
this.$axios({
method: 'post',
url: '/wechat/ekycToKen.do',
data: {
openId: window.sessionStorage.getItem('openId'),
}
}).then((response) => {
let uuidNum = uuidv4();
const params = {
projectId: this.$route.query.projectId,
openId: window.sessionStorage.getItem("openId"),
accessToken: response.data.result,
requestId: uuidNum,
version: "1.0.0",
bizNo: uuidNum,
}
window.sessionStorage.setItem("access_token", params.accessToken);
this.submitLiving(params).then((res) => {
}).catch(e => {
this.$vux.toast.text(e);
})
}).catch(e => {
this.$vux.toast.text(e);
window.sessionStorage.removeItem("access_token");
})
}
},
handleInputChange(e) {
if (this.operate == 2) {
const [videoFile] = e.target.files;
const size = parseInt(videoFile.size / 1024, 10);
if (/android/i.test(navigator.userAgent) && size > 20480) {
this.$vux.toast.text("录制视频文件过大，请重新录制");
this.$refs.fileInput.value = '';
return;
}

if (/iPhone/i.test(navigator.userAgent) && size > 20480) {
this.$vux.toast.text("录制视频文件过大，请重新录制");
this.$refs.fileInput.value = '';
return;
}
this.uploadVideo(videoFile);
}

},
async getSign(url) {
let sign = await encrypt.default.handleEncrypt(sm3, url);
return sign;
},
async getSignURL() {
return new Promise((resolve, reject) => {
this.$axios({
method: 'post',
url: '/wechat/getEkycDomain.do',
}).then(async (response) => {
if (response.data.code != 200) {
resolve([null, response.data.result.erMsg])
} else {
const ekycDomain = response.data.result;
const ekycDomainBase6 = Buffer.from(ekycDomain, 'base64').toString('utf-8')
var json = JSON.parse(ekycDomainBase6);
let obj = {
appId: json.appId,
url: json.url,
}
resolve([obj, null])
}
}).catch(e => {
resolve([null, e])
})
});
},
submitLiving(params) {
return new Promise((resolve, reject) => {
this.$axios({
method: 'post',
url: '/wechat/ekycSubmitIdcard.do',
data: params,
loadingText: '识别中...'
}).then(async (response) => {

if (response.data.code != 200) {
window.sessionStorage.removeItem("biz_token");
window.sessionStorage.removeItem("request_id");
window.sessionStorage.removeItem("biz_no");

const thiss = this;
thiss.$vux.confirm.show({
content: response.data.message, showCancelButton: false, confirmText: '关闭', hideOnBlur: false,
onConfirm() {
thiss.$router.go(-1);
}
});
} else {
let [obj, err] = await this.getSignURL()
if (err) {
window.sessionStorage.removeItem("biz_token");
window.sessionStorage.removeItem("request_id");
window.sessionStorage.removeItem("biz_no");
reject(err)
} else {
const domain = window.location.origin; 
const path = window.location.pathname;   
let requestObj = {
appid: obj.appId,
requestId: params.requestId,
version: '1.0.0',
backurl: encodeURI(domain + "" + path + "?encodeBackurl=" + Buffer.from(window.location.href).toString('base64'))
}
window.sessionStorage.setItem('biz_token', response.data.result);
window.sessionStorage.setItem('request_id', requestObj.requestId);
window.sessionStorage.setItem('biz_no', params.bizNo);
let urlLoad = `app_id=${requestObj.appid}&request_id=${requestObj.requestId}&version=${requestObj.version}&backurl=${requestObj.backurl}
&from=h5&biz_token=${response.data.result}&biz_no=${params.bizNo}&mode_type=1&link_type=1&video_type=0`;
let url = `${obj.url}/#/reminder?${encodeURIComponent(urlLoad)}`;
let sign = await this.getSign(url);
window.location.href = `${obj.url}/#/reminder?${encodeURIComponent(urlLoad + '&sign=' + sign)}`;
resolve();
}
}
}).catch(e => {
window.sessionStorage.removeItem("biz_token");
window.sessionStorage.removeItem("request_id");
window.sessionStorage.removeItem("biz_no");
reject(e)
})
});
},
uploadVideo(videoFile) {
let bucket = this.$route.query.bucket;
let fileFormData = new FormData();
fileFormData.append("file", videoFile);
fileFormData.append("token", this.token);
this.isRecognition = true;
let uploadUrl = localStorage.getItem('uploadUrl') || ''
this.$axios({
method: 'post',

url: uploadUrl,
headers: {
"Content-Type": "multipart/form-data",
},
data: fileFormData
}).then((response) => {

console.log('上传成功')
this.videoValid();
}).catch(e => {
this.$refs.fileInput.value = '';
this.isRecognition = false;
})
},
videoValid() {
const projectId = this.$route.query.projectId;
const openId = window.sessionStorage.getItem("openId");
const taskType = this.$route.query.taskType;
this.$axios({
method: 'post',
url: '/wechat/livenessDetectionValid.do',
data: {
key: this.key,
projectId,
openId,
taskType,
bizType: '2',
accessToken: window.sessionStorage.getItem('access_token'),
requestId: window.sessionStorage.getItem('request_id'),
version: "1.0.0",
bizNo: window.sessionStorage.getItem('biz_no'),
bizToken: window.sessionStorage.getItem('biz_token'),
},
loadingText: '识别中...'
}).then((response) => {
let {erCode = null, erMsg = '验证失败', verifycode, key, token} = response.data.result;
if (response.data.code === 200) {
const projectId = this.$route.query.projectId;
const openId = window.sessionStorage.getItem("openId");
const noticeUrl = "/wechat/supplementaryNotice";
this.$axios({
method: 'post',
url: noticeUrl,
data: {
projectId: projectId,
openId: openId,
}
})
if (erCode == '000000') {
console.log("taskType:" + taskType)
if (taskType === '1') {
this.sign();
} else {
this.show = true;
}
this.isRecognition = false;
} else if (erCode == '000080') {

this.$vux.toast.text(erMsg + ',请重新录制视频');
this.verifycode = verifycode;
this.key = key;
this.token = token;
this.$refs.fileInput.value = '';
this.isRecognition = false;
this.ekycFace();
} else {
const thiss = this;
thiss.$vux.confirm.show({
content: erMsg, showCancelButton: false, confirmText: '关闭', hideOnBlur: false,
onConfirm() {
if (thiss.operate == 3) {
thiss.$router.go(-2);
}
}
});
this.$refs.fileInput.value = '';
this.isRecognition = false;
}
} else {
const thiss = this;
thiss.$vux.confirm.show({
content: erMsg, showCancelButton: false, confirmText: '确认', hideOnBlur: false,
onConfirm() {
if (thiss.operate == 3) {
thiss.$router.go(-2);
}
}
})
this.$refs.fileInput.value = '';
this.isRecognition = false;

}
})
},
onCancel() {
this.onConfirm();
},
onConfirm() {
if (this.currentkey == '2') {
const $this = this;
$this.$router.push({
path: '/productDetail',
query: {
projectId: $this.$route.query.projectId,
productCode: $this.$route.query.productCode,
productId: $this.$route.query.productId
}
})
} else if (this.currentkey == '1') {
this.$router.push({
path: '/waitTask',
});
} else {
if (typeof WeixinJSBridge !== 'undefined') {
WeixinJSBridge.call('closeWindow');
} else {
this.$router.push({
path: '/waitTask',
});
}
}
},

sign() {


const url = "wechat/completeOnlineSign.do";
const projectId = this.$route.query.projectId;
const productCode = this.$route.query.productCode;
const openId = window.sessionStorage.getItem("openId");
this.$axios({
method: 'post',
url: url,
data: {
projectId: projectId,
openId: openId,
}
}).then((response) => {
if (response.data.code === 200) {

setTimeout(() => {
if (this.currentkey == '1') {
this.$router.push({
path: '/waitTask',
});
} else {
WeixinJSBridge.call('closeWindow');
}
}, 3000);
this.$vux.toast.show({text: response.data.message, time: 3000});
} else {
this.$vux.toast.show({text: response.data.message, time: 3000});
}
}).catch((err) => {
});
},
}
}



// WEBPACK FOOTER //
// ./src/pages/LivefaceRecognition.vue